import { AlertResponse, MediasResponse } from "../types/media";
import { TaskLinks } from "../types/taskLink";
import { MediasViewListMobile } from "./MediasViewListMobile";
import { MediasViewArticleListMobile } from "./MediasViewArticleListMobile";
import { GreyRow } from "../styles/styles";
import { Trans } from "@coworker/locales";
import { ArticleWithMediaCount } from "../types/article";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface MediasViewSearchListMobileProps {
  mediasResponse: MediasResponse | undefined;
  taskCountsByMediaId: Map<string, number>;
  alerts: AlertResponse[] | undefined;
  storeId: string;
  articles: ArticleWithMediaCount[] | undefined;
}

export function MediasViewSearchListMobile({
  mediasResponse,
  taskCountsByMediaId,
  alerts,
  storeId,
  articles,
}: MediasViewSearchListMobileProps) {
  // Calculate taskLinks from taskCountsByMediaId for article list compatibility
  // TODO: Refactor MediasViewArticleListMobile to also use v1+v2 combined counts
  const taskLinks: TaskLinks = [];

  return (
    <>
      <MediasViewListMobile
        mediasResponse={mediasResponse}
        taskCountsByMediaId={taskCountsByMediaId}
        alerts={alerts}
      />

      {!!articles && articles.length > 0 && (
        <GreyRow>
          <FixaText>
            <b>
              <Trans count={articles?.length ?? 0}>countArticlesString</Trans>
            </b>
          </FixaText>
        </GreyRow>
      )}
      <MediasViewArticleListMobile
        articles={articles}
        taskLinks={taskLinks}
        storeId={storeId}
      />
    </>
  );
}
